import styled from 'styled-components';
import * as Toolkit from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../../enums';

type Props = {
	mode: string;
};

export const Wrapper = styled.div`
	align-items: center;
	display: flex;

	@media (max-width: ${ScreenSize.small}) {
		align-items: initial;
	}
`;

const viewMode = `
	@media (min-width: 421px) and (max-width: ${ScreenSize.small}) {
		margin-top: 15px;
	}
	@media (min-width: ${ScreenSize.small}) and (max-width: ${ScreenSize.large}) {
		margin-top: -15px;
	}
`;

const createMode = `
    @media (max-width: 380px) {
        margin-top: 0px;
    }
    @media (min-width: 381px) and (max-width: ${ScreenSize.small}) {
        margin-top: 10px;
    }
`;

export const Checkbox = styled(Toolkit.Checkbox)`
	margin-bottom: 0;
	margin-top: 0;
	${(p: Props) => (p.mode === 'edit' ? createMode : viewMode)}
`;
